import { hasMutation, customCommit } from '../helpers.js';

const setDraftWaypoints = (
/** Optional mutations require type casting */
commit, orderDataArray, store) => {
    let draftWaypointsSet = 'N/A';
    let draftWaypoints = {};
    if (hasMutation(store, 'waypoint/SET_DRAFT_WAYPOINTS')) {
        orderDataArray.forEach((orderDataPoint) => {
            draftWaypoints = {
                ...draftWaypoints,
                ...orderDataPoint.draftWaypointsData,
            };
        });
        draftWaypointsSet = Object.keys(draftWaypoints).length;
        customCommit(commit, 'waypoint/SET_DRAFT_WAYPOINTS', draftWaypoints);
    }
    return { draftWaypointsSet, draftWaypoints };
};

export { setDraftWaypoints };
